import { CloseSVG } from "../Input/close";
import { Button, Text, Img, Heading, Input } from "./..";
import React from "react";

export default function Header({ ...props }) {
  const [searchBarValue, setSearchBarValue] = React.useState("");
  console.log(searchBarValue);

  return (
    <header
      {...props}
      className={`${props.className} flex flex-col items-center`}
    >
      <div className="container-sm flex flex-col items-center gap-3 px-14 lg:px-5 md:px-5">
        <div className="flex w-[30%] flex-col items-center gap-6 p-2 lg:w-full md:w-full">
          <div className="flex gap-4">
            <Heading
              size="heading3xl"
              as="h4"
              className="flex items-center justify-center rounded-lg bg-white-a700 px-[34px] py-0.5 text-[24px] font-bold !text-gray-900_02 lg:text-[20px] sm:px-4"
            >
              Ninja
            </Heading>
            <a
              href="https://shop.suplyd.com"
              className="flex h-[44px] min-w-[170px] flex-row items-center justify-center rounded-lg bg-white-a700_71 px-[34px] text-center text-[24px] text-black-900 opacity-25 lg:text-[20px] sm:px-4"
            >
              Shop
            </a>
          </div>
          <div className="mx-2.5 flex w-[86%] flex-col items-center justify-center gap-3.5 lg:w-full md:mx-0 md:w-full">
            <Heading
              as="h6"
              className="text-[16px] font-bold tracking-[0.25px] !text-white-a700 lg:text-[13px]"
            >
              Reach your goals faster with our expertise{" "}
            </Heading>
            <Input
              name="search"
              placeholder={`What do you want to get better at?`}
              value={searchBarValue}
              onChange={(e) => setSearchBarValue(e.target.value)}
              prefix={
                <div className="flex h-[48px] w-[48px] items-center justify-center rounded-[50%]">
                  <Img
                    src="images/img_search.svg"
                    alt="Search"
                    className="h-[24px] w-[24px] rounded-[50%] object-contain p-3"
                  />
                </div>
              }
              suffix={
                searchBarValue?.length > 0 ? (
                  <CloseSVG
                    onClick={() => setSearchBarValue("")}
                    height={24}
                    width={24}
                    fillColor="#595959ff"
                  />
                ) : null
              }
              className="flex h-[48px] items-center justify-center gap-4 self-stretch rounded-[24px] border-[0.5px] border-solid border-gray-400_01 bg-white-a700 px-3.5 text-[14px] tracking-[0.25px] text-blue_gray-400"
            />
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-1">
          <a href="#">
            <Img src="images/img_close.svg" alt="Close" className="h-[18px]" />
          </a>
          <Heading
            size="headingmd"
            as="p"
            className="text-[14px] font-bold tracking-[0.25px] !text-white-a700"
          >
            Trending Questions
          </Heading>
          <a href="#">
            <Img src="images/img_close.svg" alt="Close" className="h-[18px]" />
          </a>
        </div>
        <div className="mr-5 flex flex-nowrap w-full gap-2 self-start overflow-auto px-14 md:mr-0 md:px-5 sm:items-center sm:px-0">
          <Button
            onClick={(e) => setSearchBarValue(e.target.innerHTML)}
            className="flex-none h-[32px] rounded-[16px] border border-solid border-blue_gray-400 px-[19px] text-center text-[14px] tracking-[0.10px] text-white-a700"
          >
            How can I choose a restaurant location?
          </Button>
          <Button
            onClick={(e) => setSearchBarValue(e.target.innerHTML)}
            className="flex-none h-[32px] rounded-[16px] border border-solid border-blue_gray-400 px-[19px] text-center text-[14px] tracking-[0.10px] text-white-a700"
          >
            Controlling Utility Costs
          </Button>
          <Button
            onClick={(e) => setSearchBarValue(e.target.innerHTML)}
            className="flex-none h-[32px] rounded-[16px] border border-solid border-blue_gray-400 px-[29px] text-center text-[14px] tracking-[0.10px] text-white-a700"
          >
            Can Consolidating Purchases REALLY Lower
          </Button>
        </div>
      </div>
    </header>
  );
}
